class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHoverEvents();
  }

  setupHoverEvents() {
    const summary = this.querySelector('summary');
    const content = this.querySelector('.mega-menu__content');
    
    if (!summary || !content) return;

    // 延迟关闭的定时器
    this.closeTimer = null;

    // 鼠标进入时打开菜单
    summary.addEventListener('mouseenter', () => {
      this.clearCloseTimer();
      this.open();
    });

    // 鼠标离开整个菜单区域时延迟关闭
    this.addEventListener('mouseleave', (e) => {
      // 检查鼠标是否移动到菜单内容区域
      if (!content.contains(e.relatedTarget)) {
        this.closeTimer = setTimeout(() => {
          this.close();
        }, 150); // 150ms 延迟
      }
    });

    // 鼠标进入菜单内容区域时保持打开
    content.addEventListener('mouseenter', () => {
      this.clearCloseTimer();
      this.open();
    });

    // 鼠标离开菜单内容区域时延迟关闭
    content.addEventListener('mouseleave', (e) => {
      // 检查鼠标是否移动到菜单标题区域
      if (!summary.contains(e.relatedTarget)) {
        this.closeTimer = setTimeout(() => {
          this.close();
        }, 150); // 150ms 延迟
      }
    });
  }

  clearCloseTimer() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.onToggle();
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
